import type * as React from "react";
import { Accordion as BaseAccordion } from "@base-ui/react/accordion";
import { ChevronDown } from "lucide-react";
import { cn } from "../lib/cn";

export const Accordion = BaseAccordion.Root;

export function AccordionItem({ className, ...props }: React.ComponentProps<typeof BaseAccordion.Item>) {
  return <BaseAccordion.Item className={cn("border-b border-charcoal-100 last:border-b-0", className)} {...props} />;
}

export function AccordionTrigger({ className, children, ...props }: React.ComponentProps<typeof BaseAccordion.Trigger>) {
  return (
    <BaseAccordion.Header>
      <BaseAccordion.Trigger
        className={cn(
          "group flex w-full items-center justify-between gap-4 py-4 text-start font-medium text-charcoal-800",
          "transition-colors hover:text-primary-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          className,
        )}
        {...props}
      >
        {children}
        <ChevronDown className="h-4 w-4 shrink-0 text-charcoal-400 transition-transform duration-200 group-data-[panel-open]:rotate-180 group-data-[panel-open]:text-primary-600" />
      </BaseAccordion.Trigger>
    </BaseAccordion.Header>
  );
}

export function AccordionContent({ className, ...props }: React.ComponentProps<typeof BaseAccordion.Panel>) {
  return <BaseAccordion.Panel className={cn("overflow-hidden pb-4 text-sm text-charcoal-500", className)} {...props} />;
}
